import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation ImportBambooHRTimeOffTypesMutation($input: ImportBambooHRTimeOffTypesInput!) {
		importBambooHRTimeOffTypes(input: $input) {
			company {
				idleTimes(first: 1000) @connection(key: "Company_idleTimes") {
					edges {
						node {
							...settingsIdleTimes_idleTime @relay(mask: false)
						}
					}
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
